// extracted by mini-css-extract-plugin
export default {"content":"form-container_content__QF6jd"};